import { NgModule } from '@angular/core'
import { ChemiScorePipe } from './chemi-score.pipe'
import { FloatFixedPipe } from './float-fixed.pipe'
import { GroupChemiBackgroundColorPipe } from './group-chemi-background.pipe'
import { ImageUrlPipe } from './image-url.pipe'
import { IsHostReportRemovedPipe } from './is-host-report-removed.pipe'
import { IsStringPipe } from './is-string.pipe'
import { LocalePipe } from './locale.pipe'
import { LocaleNamePipe } from './localeName.pipe'
import { MaxPipe } from './max.pipe'
import { MbtiColorPipe } from './mbti-color.pipe'
import { MbtiImagePipe } from './mbti-image.pipe'
import { MbtiLinkPipe } from './mbti-link.pipe'
import { MbtiNickPipe } from './mbti-nick.pipe'
import { MinPipe } from './min.pipe'
import { NamePipe } from './name.pipe'
import { ProfileImagePipe } from './profile-image.pipe'
import { QuestionTitlePipe } from './question-title.pipe'
import { QuizNamePipe } from './quiz-name.pipe'
import { ReplacePostPositionPipe } from './replace-post-position.pipe'
import { ReplacePipe } from './replace.pipe'
import { RoundingPipe } from './rounding.pipe'
import { SafeHTMLPipe } from './safe-html.pipe'
import { SajuBirthTimePipe } from './saju-birthtime.pipe'
import { SurveyColorPipe } from './survey-color.pipe'
import { TimeDistancePipe } from './time-distance.pipe'

@NgModule({
  declarations: [
    MbtiColorPipe,
    RoundingPipe,
    QuestionTitlePipe,
    MbtiLinkPipe,
    MbtiNickPipe,
    ProfileImagePipe,
    TimeDistancePipe,
    SafeHTMLPipe,
    ChemiScorePipe,
    ReplacePostPositionPipe,
    MbtiImagePipe,
    FloatFixedPipe,
    GroupChemiBackgroundColorPipe,
    SurveyColorPipe,
    NamePipe,
    LocalePipe,
    LocaleNamePipe,
    ImageUrlPipe,
    QuizNamePipe,
    IsHostReportRemovedPipe,
    ReplacePipe,
    SajuBirthTimePipe,
    MinPipe,
    MaxPipe,
    IsStringPipe,
  ],
  imports: [],
  exports: [
    MbtiColorPipe,
    RoundingPipe,
    QuestionTitlePipe,
    MbtiLinkPipe,
    MbtiNickPipe,
    ProfileImagePipe,
    TimeDistancePipe,
    SafeHTMLPipe,
    ChemiScorePipe,
    ReplacePostPositionPipe,
    MbtiImagePipe,
    FloatFixedPipe,
    GroupChemiBackgroundColorPipe,
    SurveyColorPipe,
    NamePipe,
    LocalePipe,
    LocaleNamePipe,
    ImageUrlPipe,
    QuizNamePipe,
    IsHostReportRemovedPipe,
    ReplacePipe,
    SajuBirthTimePipe,
    MinPipe,
    MaxPipe,
    IsStringPipe,
  ],
})
export class PipesModule {}
